import { Pipe, PipeTransform } from '@angular/core';

/**
 * Makes only the first word upper cased.
 * EX:
 * This Is A Sentence. -> This is a sentence.
 */
@Pipe({
    name: 'sentenceCase',
    standalone: false
})
export class SentenceCasePipe implements PipeTransform {
    transform(value: string): string {
        let newString = value.toLowerCase();

        newString = `${newString[0].toUpperCase()}${newString.slice(
            1,
            newString.length
        )}`;
        return newString;
    }
}
